import { useRouter } from 'next/router';
import { useConfig } from '@app/config';
import { getTokensWhitelist } from '@app/constants/tokensWhitelist';
import { useMemo } from 'react';
import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';
import { Token } from '@app/types/token';

export function useInitialTokensData() {
  const router = useRouter();
  const { token0, token1 } = router.query;

  const config = useConfig();

  const TOKENS_WHITELIST = getTokensWhitelist(config);

  const initialData = useMemo(() => {
    if (!TOKENS_WHITELIST || !token0 || !token1) {
      return;
    }

    const _token0 = token0 as string;
    const _token1 = token1 as string;

    const tokenA =
      _token0 === NATIVE_TOKEN_ADDRESS
        ? {
            symbol: 'ETH',
            decimals: 18,
            name: 'ETH',
            contractAddress: NATIVE_TOKEN_ADDRESS,
            logoUri: ''
          }
        : TOKENS_WHITELIST.find(
            item => item.contractAddress.toLowerCase() === _token0.toLowerCase()
          );
    const tokenB =
      _token1 === NATIVE_TOKEN_ADDRESS
        ? {
            symbol: 'ETH',
            decimals: 18,
            name: 'ETH',
            contractAddress: NATIVE_TOKEN_ADDRESS,
            logoUri: ''
          }
        : TOKENS_WHITELIST.find(
            item => item.contractAddress.toLowerCase() === _token1.toLowerCase()
          );

    if (!tokenA || !tokenB) {
      return;
    }

    return {
      from: {
        amount: '',
        token: {
          symbol: tokenA.symbol,
          decimals: +tokenA.decimals,
          name: tokenA.name,
          contractAddress: tokenA.contractAddress,
          logoUri: ''
        } satisfies Token
      },
      to: {
        amount: '',
        token: {
          symbol: tokenB.symbol,
          decimals: +tokenB.decimals,
          name: tokenB.name,
          contractAddress: tokenB.contractAddress,
          logoUri: ''
        } satisfies Token
      }
    };
  }, [TOKENS_WHITELIST, token0, token1]);

  return {
    initialData
  };
}
